export const CONFIG_FETCH='CONFIG_FETCH';
export const CONFIG_IS_FETCING='CONFIG_IS_FETCHING';



// WEBPACK FOOTER //
// ./src/constants/config.js